import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage.tsx';
import SuccessPage from './pages/SuccessPage.tsx';
import CreateVoucherPage from './pages/CreateVoucherPage.tsx';
import { RequireVoucher, RequireUserDetails, RedirectToSuccessOnUserDetails, PopToHomeWithTokenClear } from './routes/guards.tsx';

function App(): JSX.Element {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:code" element={<HomePage />} />
          <Route path="/create-voucher" element={
            <RequireVoucher>
              <RedirectToSuccessOnUserDetails>
                <PopToHomeWithTokenClear>
                  <CreateVoucherPage />
                </PopToHomeWithTokenClear>
              </RedirectToSuccessOnUserDetails>
            </RequireVoucher>
          } />
          <Route path="/success" element={
            <RequireVoucher>
              <RequireUserDetails>
                <PopToHomeWithTokenClear>
                  <SuccessPage />
                </PopToHomeWithTokenClear>
              </RequireUserDetails>
            </RequireVoucher>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App; 